import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";
import HeaderLogo from '../../components/HeaderLogo'
import Button from '../../components/Button';

function ProductPage({tileslist, yaneawlist, handleSetProduct, resetDetails, setYaneaw, setTile, type}) {
    const [selectedTile, setSelectedTile] = useState(0)
    const [selectedYaneaw, setSelectedYaneaw] = useState(0)
    const [firstload, setFirstload] = useState(true)

    useEffect(()=>{
        let defaultTileIndex = 0
        if(type ==='floor')
            defaultTileIndex = tileslist.findIndex(element => element.type === "floor");
        else if(type ==='wall')
            defaultTileIndex = tileslist.findIndex(element => element.type === "ceiling");
        resetDetails()
        handleSetTile(defaultTileIndex)
        handleSetYaneaw(0)
        matchYaneaw(defaultTileIndex)
        tileslist.forEach((tile) => {
            const img = new Image();
            img.src = tile.layerImage;
        });
    },[])

    function handleSubmit(){
        handleSetProduct()
    }
    function handleSetTile(t){
        const tile = tileslist?.[t]
        setTile(tile)
        setSelectedTile(t)
        matchYaneaw(t)

        // var c1 = document.getElementById("tile-anchor").offsetTop
        // var c2 = document.getElementById("yaneaw-anchor").offsetTop
        // if(!firstload){
        //     window.scrollTo({
        //         top: c2-c1,
        //         behavior: 'smooth'
        //     });
        // }
        // setFirstload(false)
    }
    function matchYaneaw(t){
        const tile = tileslist?.[t]
        const y = yaneawlist?.findIndex(el=>el.value===tile.yaneaw)
        const yaneaw = yaneawlist?.[y]
        if(yaneaw){
            setYaneaw(yaneaw)
            setSelectedYaneaw(y)
        } 
    }
    function handleSetYaneaw(y){
        const yaneaw = yaneawlist?.[y]
        setYaneaw(yaneaw)
        setSelectedYaneaw(y)
    }
    return (
        <div className="page-container" style={{overflow: 'hidden'}}>
            {/* <HeaderLogo /> */}
            <div className="fix-position" style={{boxShadow: '0 3px 5px 0px rgba(0, 0, 0, 0.2)'}}>
                <div className="flex row mainpadding">
                    <Link to="/tiles/notiles/type" className="back-button">
                        <div>{'< กลับ'}</div>
                    </Link>
                    <div className="bread-crump">
                        <span className="h5 grey-text semibold">
                            <span className="green-text">รายละเอียด</span> / เลือกบริการ / สรุปข้อมูล
                        </span>
                    </div>
                </div>
                {/* <div className="cover-title-card box-shadow">
                    <div className="cover-header-container red-bg box-shadow h3">เลือกกระเบื้อง + หาช่าง</div>        
                </div> */}
                <div className="mainpadding alight-left" style={{paddingBottom: '0', paddingTop: '0',marginBotton: '3%',margin: 'auto'}}>
                    <div className="h3"><span className="h1 bold">ROOM-ID</span> - Custom your style</div>
                    <div className="layer-wrapper">
                        <img className="layer-image-container" src={yaneawlist?.[selectedYaneaw]?.layerImage} />
                        <img className="layer-image-container" src={tileslist?.[selectedTile]?.layerImage} />
                        <img className="layer-image-container" src={tileslist?.[selectedTile]?.topLayer} />
                        <div className="ratio-keeper"></div>
                    </div>
                    <div className="product-footer-wrapper h6">*หมายเหตุ ภาพดังกล่าวเป็นเพียงตัวอย่างประกอบการติดตั้งเท่านั้น</div>
                </div>
            </div>
            <div className="fix-margin">
                <div className="mainpadding">
                    <div id="tile-anchor" className="product-header-container green-bg box-shadow h3">Step 1 : เลือกกระเบื้องที่ชอบ</div> 
                    <div>
                        {
                            type==="floor"?
                            (
                                <div className="product-wrapper">
                                    {
                                        tileslist.map((val, index)=>{
                                            if(val?.type==="floor")
                                            return(
                                                <div 
                                                key={index}
                                                className="product-container"
                                                onClick={()=>handleSetTile(index)}
                                                >
                                                    <img 
                                                    className={index===selectedTile?"product-image-container active":"product-image-container"} 
                                                    src={val.image} 
                                                    />
                                                    <div className="h5">{val.name}</div>
                                                    <div className="h6">{val.size}</div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            ):null
                        }
                        {
                            type==="wall"?
                            (
                                <div className="product-wrapper">
                                    {
                                        tileslist.map((val, index)=>{
                                            if(val?.type==="ceiling")
                                            return(
                                                <div 
                                                key={index}
                                                className="product-container"
                                                onClick={()=>handleSetTile(index)}
                                                >
                                                    <img 
                                                    className={index===selectedTile?"product-image-container active":"product-image-container"}  
                                                    src={val.image} 
                                                    />
                                                    <div className="h5">{val.name}</div>
                                                    <div className="h6">{val.size}</div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            ):null
                        }
                    </div>
                </div>
                <div className="mainpadding">
                    <div id="yaneaw-anchor" className="product-header-container green-bg box-shadow h3">Step 2 : เลือกสียาแนวที่ใช่</div> 
                    <div>
                        <div className="yaneaw-wrapper">
                            {
                                yaneawlist.map((val, index)=>{
                                    return(
                                        <div 
                                        key={index}
                                        className="yaneaw-container"
                                        onClick={()=>handleSetYaneaw(index)}>
                                            <img 
                                            className={index===selectedYaneaw?"yaneaw-image-container active":"yaneaw-image-container"} 
                                            src={val.image} 
                                            />
                                            <div>{val.name}</div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                <Button 
                fullWidth 
                text={'กรอกรายละเอียด >'} 
                bigText={true}
                onPress={handleSubmit}
                />
            </div>
        </div>
    );
}

export default ProductPage;
